import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ActionItemService {
  
  public aldURL: string;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
      this.aldURL = this.appConfig.getAppConfig().AldUrl;
  }

  getActionItemsByRequestId(requestId: any) : Observable<any> {
    return this.http.get<any> (this.aldURL + '/api/ActionItems/GetActionItemsByRequestId?requeistId=' + requestId);
  }

  save(actionItem: any) : Observable<any> {
    return this.http.post<any> (this.aldURL + '/api/ActionItems/Save', actionItem);
  }


}